export enum SearchTabs {
    Website = "website",
    Keyword = "keyword",
}

export type OnSearchItemClick = (name?: string, state?: string) => void;
